import { useState, useEffect, useRef } from 'react'
import axios from 'axios'

const useFormLogic = () => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('+')
  const [email, setEmail] = useState('')
  const [isAgreed, setIsAgreed] = useState(false)
  const phoneInputRef = useRef(null)
  const [errors, setErrors] = useState({})
  const [selectedCourse, setSelectedCourse] = useState('')
  const [res, setRes] = useState('')

  useEffect(() => {
    const phoneInputs = document.querySelectorAll('input[data-tel-input]')

    const getInputNumbersValue = (input) => {
      return input.value.replace(/\D/g, '')
    }

    const onPhonePaste = (e) => {
      const input = e.target
      const inputNumbersValue = getInputNumbersValue(input)
      const pasted = e.clipboardData || window.clipboardData
      if (pasted) {
        const pastedText = pasted.getData('Text')
        if (/\D/g.test(pastedText)) {
          input.value = inputNumbersValue
          return
        }
      }
    }

    const onPhoneInput = (e) => {
      const input = e.target
      let inputNumbersValue = getInputNumbersValue(input)
      const selectionStart = input.selectionStart
      let formattedInputValue = ''
      if (!inputNumbersValue) {
        input.value = '+'
        setPhone('+')
        return
      }

      if (input.value.length !== selectionStart) {
        if (e.data && /\D/g.test(e.data)) {
          input.value = inputNumbersValue
        }
        return
      }

      if (inputNumbersValue[0] === '8') {
        formattedInputValue = '8'
      } else if (['7', '9'].includes(inputNumbersValue[0])) {
        formattedInputValue = '+7'
      }
      if (inputNumbersValue[0] === '8') {
        if (inputNumbersValue.length > 1) {
          formattedInputValue += '(' + inputNumbersValue.substring(1, 4)
        }
        if (inputNumbersValue.length >= 5) {
          formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
        }
        if (inputNumbersValue.length >= 8) {
          formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
        }
        if (inputNumbersValue.length >= 10) {
          formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
        }
      } else if (['7', '9'].includes(inputNumbersValue[0])) {
        if (inputNumbersValue[0] === '9')
          inputNumbersValue = '7' + inputNumbersValue
        if (inputNumbersValue.length > 1) {
          formattedInputValue += '(' + inputNumbersValue.substring(1, 4)
        }
        if (inputNumbersValue.length >= 5) {
          formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
        }
        if (inputNumbersValue.length >= 8) {
          formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
        }
        if (inputNumbersValue.length >= 10) {
          formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
        }
      } else {
        formattedInputValue = '+' + inputNumbersValue.substring(0, 16)
      }
      if (inputNumbersValue.length > 11) {
        inputNumbersValue = inputNumbersValue.substring(0, 11)
        if (inputNumbersValue[0] === '8') {
          formattedInputValue = '8'
        } else if (['7', '9'].includes(inputNumbersValue[0])) {
          formattedInputValue = '+7'
        }
        if (inputNumbersValue[0] === '8') {
          if (inputNumbersValue.length > 1) {
            formattedInputValue += '(' + inputNumbersValue.substring(1, 4)
          }
          if (inputNumbersValue.length >= 5) {
            formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
          }
          if (inputNumbersValue.length >= 8) {
            formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
          }
          if (inputNumbersValue.length >= 10) {
            formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
          }
        } else if (['7', '9'].includes(inputNumbersValue[0])) {
          if (inputNumbersValue.length > 1) {
            formattedInputValue += '(' + inputNumbersValue.substring(1, 4)
          }
          if (inputNumbersValue.length >= 5) {
            formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
          }
          if (inputNumbersValue.length >= 8) {
            formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
          }
          if (inputNumbersValue.length >= 10) {
            formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
          }
        } else {
          formattedInputValue = '+' + inputNumbersValue.substring(0, 16)
        }
      }
      input.value = formattedInputValue
      setPhone(formattedInputValue)
      const diff =
        formattedInputValue.length -
        (inputNumbersValue.length > 0 ? inputNumbersValue.length : 0)
      const newSelectionStart = Math.max(0, selectionStart + diff)
      input.selectionStart = newSelectionStart
      input.selectionEnd = newSelectionStart
    }

    const onPhoneKeyDown = (e) => {
      const input = e.target
      const inputValue = input.value.replace(/\D/g, '')
      if (e.key === 'Backspace' && inputValue.length === 1) {
        input.value = '+'
        setPhone('+')
      }
    }

    phoneInputs.forEach((phoneInput) => {
      phoneInput.addEventListener('keydown', onPhoneKeyDown)
      phoneInput.addEventListener('input', onPhoneInput, false)
      phoneInput.addEventListener('paste', onPhonePaste, false)
    })
  }, [])

  const validateForm = () => {
    const newErrors = {}
    if (!name.trim()) {
      newErrors.name = 'Имя обязательно'
    }

    if (phone === '+') {
      newErrors.phone = 'Телефон обязателен'
    }
    if (!email.trim()) {
      newErrors.email = 'Email обязателен'
    }
    if (!isAgreed) {
      newErrors.isAgreed = 'Вы должны согласиться с условиями'
    }
    if (!selectedCourse) {
      newErrors.selectedCourse = 'Вы должны выбрать курс'
    }
    setErrors(newErrors)
    // return
    if (Object.keys(newErrors).length === 0) {
      api({ name, phone, email, selectedCourse })
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    return validateForm()
  }

  const handleSelect = (value) => {
    setSelectedCourse(value)
  }

  const api = async (data) => {
    const fm = new FormData()
    for (const key in data) {
      fm.append(key, data[key])
    }
    try {
      const response = await axios.post(
        'https://freesunfilmschool.com/api/mail.php',
        fm,
      )
      setRes(response.data)
    } catch (error) {
      console.log(error)
      setRes({
        status: '',
        message:
          'Ошибка отправки сообщения. Попробуйте\u00A0позже\u00A0или\u00A0позвоните\u00A0нам.',
      })
    }
  }

  return {
    api,
    name,
    setName,
    phone,
    setPhone,
    email,
    setEmail,
    isAgreed,
    setIsAgreed,
    phoneInputRef,
    handleSubmit,
    errors,
    selectedCourse,
    setRes,
    res,
    setSelectedCourse: handleSelect, // Исправлено здесь
  }
}

export default useFormLogic
